export class ListMyMPARequestsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListMyMPARequestsRequestFilters",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<ListMPARequestsSort>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMyMPARequestsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
